"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The BilledServiceCallDataRecord model module.
 * @module model/BilledServiceCallDataRecord
 * @version 3.0
 */
var BilledServiceCallDataRecord = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>BilledServiceCallDataRecord</code>.
   * @alias module:model/BilledServiceCallDataRecord
   */
  function BilledServiceCallDataRecord() {
    _classCallCheck(this, BilledServiceCallDataRecord);
    BilledServiceCallDataRecord.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(BilledServiceCallDataRecord, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>BilledServiceCallDataRecord</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/BilledServiceCallDataRecord} obj Optional instance to populate.
     * @return {module:model/BilledServiceCallDataRecord} The populated <code>BilledServiceCallDataRecord</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new BilledServiceCallDataRecord();
        if (data.hasOwnProperty('id')) {
          obj['id'] = _ApiClient["default"].convertToType(data['id'], 'Number');
        }
        if (data.hasOwnProperty('type')) {
          obj['type'] = _ApiClient["default"].convertToType(data['type'], 'String');
        }
        if (data.hasOwnProperty('quantity')) {
          obj['quantity'] = _ApiClient["default"].convertToType(data['quantity'], 'String');
        }
        if (data.hasOwnProperty('quantityUnits')) {
          obj['quantityUnits'] = _ApiClient["default"].convertToType(data['quantityUnits'], 'String');
        }
        if (data.hasOwnProperty('origin')) {
          obj['origin'] = _ApiClient["default"].convertToType(data['origin'], 'String');
        }
        if (data.hasOwnProperty('destination')) {
          obj['destination'] = _ApiClient["default"].convertToType(data['destination'], 'String');
        }
        if (data.hasOwnProperty('cdrDateTime')) {
          obj['cdrDateTime'] = _ApiClient["default"].convertToType(data['cdrDateTime'], 'Date');
        }
        if (data.hasOwnProperty('description')) {
          obj['description'] = _ApiClient["default"].convertToType(data['description'], 'String');
        }
        if (data.hasOwnProperty('chargeCode')) {
          obj['chargeCode'] = _ApiClient["default"].convertToType(data['chargeCode'], 'String');
        }
        if (data.hasOwnProperty('salesPrice')) {
          obj['salesPrice'] = _ApiClient["default"].convertToType(data['salesPrice'], 'Number');
        }
        if (data.hasOwnProperty('preBundlePrice')) {
          obj['preBundlePrice'] = _ApiClient["default"].convertToType(data['preBundlePrice'], 'Number');
        }
        if (data.hasOwnProperty('bundlePrice')) {
          obj['bundlePrice'] = _ApiClient["default"].convertToType(data['bundlePrice'], 'Number');
        }
        if (data.hasOwnProperty('priceUnits')) {
          obj['priceUnits'] = _ApiClient["default"].convertToType(data['priceUnits'], 'String');
        }
        if (data.hasOwnProperty('discount')) {
          obj['discount'] = _ApiClient["default"].convertToType(data['discount'], 'Number');
        }
        if (data.hasOwnProperty('cdrClass')) {
          obj['cdrClass'] = _ApiClient["default"].convertToType(data['cdrClass'], 'String');
        }
        if (data.hasOwnProperty('network')) {
          obj['network'] = _ApiClient["default"].convertToType(data['network'], 'String');
        }
        if (data.hasOwnProperty('currency')) {
          obj['currency'] = _ApiClient["default"].convertToType(data['currency'], 'String');
        }
        if (data.hasOwnProperty('recordId')) {
          obj['recordId'] = _ApiClient["default"].convertToType(data['recordId'], 'String');
        }
        if (data.hasOwnProperty('serviceId')) {
          obj['serviceId'] = _ApiClient["default"].convertToType(data['serviceId'], 'Number');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>BilledServiceCallDataRecord</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>BilledServiceCallDataRecord</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['type'] && !(typeof data['type'] === 'string' || data['type'] instanceof String)) {
        throw new Error("Expected the field `type` to be a primitive type in the JSON string but got " + data['type']);
      }
      // ensure the json data is a string
      if (data['quantity'] && !(typeof data['quantity'] === 'string' || data['quantity'] instanceof String)) {
        throw new Error("Expected the field `quantity` to be a primitive type in the JSON string but got " + data['quantity']);
      }
      // ensure the json data is a string
      if (data['quantityUnits'] && !(typeof data['quantityUnits'] === 'string' || data['quantityUnits'] instanceof String)) {
        throw new Error("Expected the field `quantityUnits` to be a primitive type in the JSON string but got " + data['quantityUnits']);
      }
      // ensure the json data is a string
      if (data['origin'] && !(typeof data['origin'] === 'string' || data['origin'] instanceof String)) {
        throw new Error("Expected the field `origin` to be a primitive type in the JSON string but got " + data['origin']);
      }
      // ensure the json data is a string
      if (data['destination'] && !(typeof data['destination'] === 'string' || data['destination'] instanceof String)) {
        throw new Error("Expected the field `destination` to be a primitive type in the JSON string but got " + data['destination']);
      }
      // ensure the json data is a string
      if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
        throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
      }
      // ensure the json data is a string
      if (data['chargeCode'] && !(typeof data['chargeCode'] === 'string' || data['chargeCode'] instanceof String)) {
        throw new Error("Expected the field `chargeCode` to be a primitive type in the JSON string but got " + data['chargeCode']);
      }
      // ensure the json data is a string
      if (data['priceUnits'] && !(typeof data['priceUnits'] === 'string' || data['priceUnits'] instanceof String)) {
        throw new Error("Expected the field `priceUnits` to be a primitive type in the JSON string but got " + data['priceUnits']);
      }
      // ensure the json data is a string
      if (data['cdrClass'] && !(typeof data['cdrClass'] === 'string' || data['cdrClass'] instanceof String)) {
        throw new Error("Expected the field `cdrClass` to be a primitive type in the JSON string but got " + data['cdrClass']);
      }
      // ensure the json data is a string
      if (data['network'] && !(typeof data['network'] === 'string' || data['network'] instanceof String)) {
        throw new Error("Expected the field `network` to be a primitive type in the JSON string but got " + data['network']);
      }
      // ensure the json data is a string
      if (data['currency'] && !(typeof data['currency'] === 'string' || data['currency'] instanceof String)) {
        throw new Error("Expected the field `currency` to be a primitive type in the JSON string but got " + data['currency']);
      }
      // ensure the json data is a string
      if (data['recordId'] && !(typeof data['recordId'] === 'string' || data['recordId'] instanceof String)) {
        throw new Error("Expected the field `recordId` to be a primitive type in the JSON string but got " + data['recordId']);
      }
      return true;
    }
  }]);
}();
/**
 * @member {Number} id
 */
BilledServiceCallDataRecord.prototype['id'] = undefined;

/**
 * @member {String} type
 */
BilledServiceCallDataRecord.prototype['type'] = undefined;

/**
 * @member {String} quantity
 */
BilledServiceCallDataRecord.prototype['quantity'] = undefined;

/**
 * @member {String} quantityUnits
 */
BilledServiceCallDataRecord.prototype['quantityUnits'] = undefined;

/**
 * @member {String} origin
 */
BilledServiceCallDataRecord.prototype['origin'] = undefined;

/**
 * @member {String} destination
 */
BilledServiceCallDataRecord.prototype['destination'] = undefined;

/**
 * @member {Date} cdrDateTime
 */
BilledServiceCallDataRecord.prototype['cdrDateTime'] = undefined;

/**
 * @member {String} description
 */
BilledServiceCallDataRecord.prototype['description'] = undefined;

/**
 * @member {String} chargeCode
 */
BilledServiceCallDataRecord.prototype['chargeCode'] = undefined;

/**
 * @member {Number} salesPrice
 */
BilledServiceCallDataRecord.prototype['salesPrice'] = undefined;

/**
 * @member {Number} preBundlePrice
 */
BilledServiceCallDataRecord.prototype['preBundlePrice'] = undefined;

/**
 * @member {Number} bundlePrice
 */
BilledServiceCallDataRecord.prototype['bundlePrice'] = undefined;

/**
 * @member {String} priceUnits
 */
BilledServiceCallDataRecord.prototype['priceUnits'] = undefined;

/**
 * @member {Number} discount
 */
BilledServiceCallDataRecord.prototype['discount'] = undefined;

/**
 * @member {String} cdrClass
 */
BilledServiceCallDataRecord.prototype['cdrClass'] = undefined;

/**
 * @member {String} network
 */
BilledServiceCallDataRecord.prototype['network'] = undefined;

/**
 * @member {String} currency
 */
BilledServiceCallDataRecord.prototype['currency'] = undefined;

/**
 * @member {String} recordId
 */
BilledServiceCallDataRecord.prototype['recordId'] = undefined;

/**
 * @member {Number} serviceId
 */
BilledServiceCallDataRecord.prototype['serviceId'] = undefined;
var _default = exports["default"] = BilledServiceCallDataRecord;